export const FILTERS_RESET_ITEMS_LIMIT = 10;
